import styled from 'styled-components';
import { pickledBluewood } from '@paradigm/design-system/src/colors';

import { TableHeader } from '../../rfq-common/TableRow';
import RfqActionHeader from '../rfqs/action/RfqActionHeader';
import { MyAsk, MyBid, MyOrdersContainer, tableCols } from './RfqRowBase';
import { StrategyGreeksHeaderRow } from './StrategyGreeks';

export function RfqHeaderRow() {
  return (
    <StyledTableHeader>
      <span>T</span>
      <span>Product</span>
      <span>Description</span>
      <RfqActionHeader />
      <span>Last</span>
      <MyQuotesHeaderRow />
      <StrategyGreeksHeaderRow />
      <span>Created</span>
    </StyledTableHeader>
  );
}

export function MyQuotesHeaderRow() {
  return (
    <MyOrdersContainer>
      <span />
      <MyBid noBackground>
        <BaseCell>Qty</BaseCell>
        <span />
        <BaseCell>My Bid</BaseCell>
      </MyBid>
      <MyAsk noBackground>
        <BaseCell>My Ask</BaseCell>
        <span />
        <BaseCell>Qty</BaseCell>
      </MyAsk>
      <span />
    </MyOrdersContainer>
  );
}

const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  box-shadow: inset 0 -1px 0 0 ${pickledBluewood};
  align-content: center;
  ${tableCols}
`;

const BaseCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
